import * as React from 'react'

const AccessRight = ({ user }) => {
  const renderFlag = (bool) =>
    bool ? (
      <i className="fas fa-check" style={{ color: 'green' }}></i>
    ) : (
      <i className="fas fa-times" style={{ color: 'red' }}></i>
    )

  return (
    <>
      <div className="mt-3">Event Access Rights:</div>
      <div className="card d-flex flex-column mt-2 p-4 w-100">
        <div>
          {user.eventAccess?.map((event, index) => (
            <div key={index}>
              <span className="fw-bold">{`${event}: `}</span>
              {renderFlag(event)}
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default AccessRight
